export default __webpack_public_path__ + "static/media/courses.3ae963a7.svg";